// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"FormButtons_buttonsWrapper__r4wQy","submitBtn":"FormButtons_submitBtn__nIWQ5","canselBtn":"FormButtons_canselBtn__-+zwA"};